import React from 'react';
import type { BookingDetail } from '../../../types';

interface BookingServiceInfoProps {
  service: BookingDetail['service'];
  dateFormatted: string;
  timeRange: string;
}

export const BookingServiceInfo: React.FC<BookingServiceInfoProps> = ({
  service,
  dateFormatted,
  timeRange,
}) => {
  return (
    <div className="mx-4 mb-4 p-4 bg-white border border-gray-200 rounded-xl">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
        Service Information
      </h3>

      <div className="space-y-3">
        {/* Service Name */}
        <div>
          <div className="text-lg font-semibold text-gray-900">
            {service.name}
          </div>
          {/* Duration and Category */}
          <div className="text-sm text-gray-600 mt-1 flex items-center gap-2">
            <span>{service.duration_min} minutes</span>
            {service.category && (
              <>
                <span className="text-gray-400">•</span>
                <span>{service.category}</span>
              </>
            )}
          </div>
        </div>

        {/* Date and Time */}
        <div className="space-y-2 pt-2 border-t border-gray-100">
          <div className="flex items-center gap-2 text-base text-gray-800">
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span>{dateFormatted}</span>
          </div>

          <div className="flex items-center gap-2 text-base font-medium text-gray-800">
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{timeRange}</span>
          </div>
        </div>

        {/* Price */}
        <div className="pt-2 border-t border-gray-100">
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-xl font-bold text-purple-600">
              {new Intl.NumberFormat('en-US', { style: 'currency', currency: service.currency || 'USD' }).format(service.price_cents / 100)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
